import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { IReduxState } from "../../interfaces/IReduxState";

export interface QuestionType {
  id: number;
  name: string;
  description?: string;
  subject_id: number;
  sequence?: number;
  Status?: boolean;
}

export const ScheduleQuestionTypesSlice = createSlice({
  name: "ScheduleQuestionTypesSlice",
  initialState: {} as IReduxState<QuestionType[]>,
  reducers: {
    scheduleQuestionTypes: (state, _action: PayloadAction<number>) => {
      state.isLoading = true;
    },
    successScheduleQuestionTypes: (state, action) => {
      state.data = action.payload;
      state.isLoading = false;
    },
    failureScheduleQuestionTypes: (state, action) => {
      state.data = action.payload;
      state.isLoading = false;
    },
  },
});

export const {
  failureScheduleQuestionTypes,
  scheduleQuestionTypes,
  successScheduleQuestionTypes,
} = ScheduleQuestionTypesSlice.actions;

export default ScheduleQuestionTypesSlice.reducer;
